import React, { useState, useEffect } from "react";
import { getLoggedInUser } from "../helpers";
import { Row, Label, Alert, Modal, ModalHeader, ModalBody } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import swal from "sweetalert";
import Loader from "./Loader/Loader";
import config from "react-global-configuration";
import "react-datepicker/dist/react-datepicker.css";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "react-i18next";

const WageringLimit = (props) => {
  const [user, setUser] = useState(getLoggedInUser());
  const [isLoading, setIsLoading] = useState(false);
  const [resMessage, setResMessage] = useState("");
  const [right, setRight] = useState(false);
  const [wrong, setWrong] = useState(false);
  const [userList, setUserList] = useState({});
  const [depositModalOpen, setDepositModalOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    loadRecordsTables();
  }, []);

  const loadRecordsTables = () => {
    setIsLoading(true);
    betSlipService
      .LimitDetails({ guid: user.guid })
      .then((res) => {
        setUserList(res[0]);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        swal(error.message, { icon: "error" });
      });
  };

  const handleValidSubmit = (event, values) => {
    setIsLoading(true);

    let formData = new FormData();
    formData.append("betting_limit", values.betting_limit);
    formData.append("password", values.password);
    formData.append("guid", user.guid);

    betSlipService
      .updateLimit(formData, config)
      .then((res) => {
        if (res.success) {
          swal({
            title: t("userProfile.limits.titles.success"),
            text: res.message,
            icon: "success",
            buttons: { confirm: "Ok" },
            successMode: true,
          }).then((result) => {
            if (result) {
              window.location.href = "/user-profile";
            }
          });
        } else {
          swal({
            title: t("userProfile.limits.titles.requiresAttention"),
            text: res.message,
            icon: "info",
            buttons: { confirm: "Ok" },
            successMode: true,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        swal(error.message, { icon: "error" });
      });
  };

  const openDepositModal = () => {
    setDepositModalOpen(true);
  };

  const closeDepositModal = () => {
    setDepositModalOpen(false);
  };

  const onTrigger = (event) => {
    props.parentCallback(true);
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="">
        <Row>
          <div className="col-md-12">
            <Alert color="success" isOpen={right}>
              {resMessage}
            </Alert>
            <Alert color="danger" isOpen={wrong}>
              {resMessage}
            </Alert>
          </div>
        </Row>
        <Row className="gy-3">
          <div className="col-md-12">
            <div className="form-group">
              <h6 id="fname" type="text" name="daily_limit">
                <span style={{ fontWeight: "100", marginRight: "15px" }}>
                  {t("userProfile.limits.dailyBettingLimit")}:
                </span>
                {userList ? userList.betting_limit : ""}{" "}
                <span style={{ fontWeight: "100", marginRight: "40px" }}>
                  {t("userProfile.limits.euro")}
                </span>
                <span>
                  <button
                    onClick={openDepositModal}
                    className="cstm_btn2 active mt-3 menu-blnce"
                  >
                    {t("userProfile.limits.editLimit")}
                  </button>
                </span>
              </h6>
            </div>
          </div>
        </Row>
        <Modal
          className="withdraw-request-popup"
          isOpen={depositModalOpen}
          // toggle={closeDepositModal}
        >
          {/* <ModalHeader toggle={closeDepositModal}></ModalHeader> */}
          <ModalBody>
            <p onClick={closeDepositModal}>
              <RxCross2 className="close-btn" />
            </p>
            <AvForm onValidSubmit={handleValidSubmit}>
              <Row className="gy-3">
                <div className="">
                  <h3 style={{ textAlign: "center" }} className="text-white">
                    {t("userProfile.limits.editBettingLimit")}
                  </h3>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <Label for="code" className="form-label text-white">
                      {t("userProfile.limits.dailyBettingLimit")}{" "}
                      <span className="required text-danger">*</span>
                    </Label>
                    <AvField
                      id="fname"
                      type="number"
                      className="form-control form--control style-two text-white"
                      name="betting_limit"
                      placeholder="Enter Limit"
                      required
                      value={userList ? userList.betting_limit : ""}
                      errorMessage={t("userProfile.limits.pleaseEnterLimit")}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-sm-12">
                  <div className="form-group">
                    <Label for="code" className="form-label text-white">
                      {t("userProfile.limits.confirmPassword")}{" "}
                      <span className="required text-danger">*</span>
                    </Label>
                    <AvField
                      id="password"
                      type="password"
                      className="form-control form--control style-two text-white"
                      name="password"
                      placeholder={t("userProfile.limits.enterPassword")}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            "userProfile.limits.pleaseEnterPassword",
                          ),
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 center">
                  <button className="cstm_btn2 active mt-3">
                    {t("userProfile.limits.update")}
                  </button>
                </div>
              </Row>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return user;
};
export default connect(mapStateToProps)(WageringLimit);
